import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { Loader } from './../../../components/loader';
import { Checkbox } from './../../../components/checkbox';
import { ThirdStageLink } from './../../order/components/thirdStage';
import _ from 'underscore';
import { setMessage } from '../../../actions/setMessage';
import { ParseError } from '../../../functions/error-parse';
import IntlTelInput from 'react-intl-tel-input';
import {
    constOnlyCountries,
    constPreferredCountries,
} from '../../../constants';
import { parsePhone } from '../../../functions/phone';
import { Button } from 'antd';
import s from './firstStage.module.scss';

function parseProps(props) {
    const order = props.order;

    return {
        first_name: order.first_name,
        phone: parsePhone(props.phone),
        email: order.email,
        delivery: order.delivery,
        addresses: order.addresses,
        comments: order.comments,
    };
}

class FirstStageModal extends Component {
    constructor(props) {
        super(props);
        this.state = parseProps(props);
        this.changeInput = this.changeInput.bind(this);
        this.editPhone = this.editPhone.bind(this);
        this.changeCheckbox = this.changeCheckbox.bind(this);
        this.confirmAction = this.confirmAction.bind(this);
    }

    changeInput(value, name, key) {
        value = value || '';
        const props = this.props;
        let object = {},
            object_in;

        if (key === undefined) {
            object[name] = value;
            object_in = value;
        } else {
            object_in = object[name] = this.state[name].concat();
            object[name][key] = value;
            object_in[key] = value;
        }
        props.setOrderData(name, object_in);
        this.setState({ ...object });
    }

    editPhone(status, value, countryData, number) {
        const phone = parsePhone(value, countryData.iso2) || '';
        this.props.setOrderData('phone', phone.trim());
        this.setState({
            phone: phone,
        });
    }

    changeCheckbox(id) {
        let state = { ...this.state },
            value = !state[id] ? 1 : 0;
        state[id] = value;
        this.setState({ ...state });
        this.props.setOrderData(id, value);
    }

    confirmAction() {
        const props = this.props,
            { dispatch, user } = props,
            { delivery, addresses, comments, first_name, phone, email } =
                props.order;

        let title_error = '',
            isError = false;

        if (!user && !isError) {
            if (
                !first_name &&
                props.setting.rightModal.noAuth.name.visible &&
                props.setting.rightModal.noAuth.name.required
            ) {
                title_error = props.setting.rightModal.noAuth.name.title;
                isError = true;
            } else if (
                !phone &&
                props.setting.rightModal.noAuth.phone.visible &&
                props.setting.rightModal.noAuth.phone.required
            ) {
                title_error = props.setting.rightModal.noAuth.phone.title;
                isError = true;
            } else if (
                !email &&
                props.setting.rightModal.noAuth.email.visible &&
                props.setting.rightModal.noAuth.email.required
            ) {
                title_error = props.setting.rightModal.noAuth.email.title;
                isError = true;
            }
        }

        if (!isError && delivery)
            isError = _.find(
                props.setting.rightModal.body.addresses,
                (address, key) => {
                    const state_address = addresses[key],
                        { title, required } = address;
                    if (required && !state_address) {
                        title_error = title;
                        return true;
                    }
                }
            );

        if (!isError)
            isError = _.find(
                props.setting.rightModal.body.comments,
                (comment, key) => {
                    const state_comment = comments[key],
                        { title, required } = comment;
                    if (required && !state_comment) {
                        title_error = title;
                        return true;
                    }
                }
            );
        // \s - любой вид пробела, g - заменяются все сопаставления
        if (phone.replace(/\s/g, '').length !== 12) {
            dispatch(
                setMessage(
                    ParseError(
                        'Поле &laquo;' +
                            'Телефон' +
                            '&raquo; имеет не верный формат.'
                    ),
                    'error'
                )
            );
            return;
        }

        if (isError) {
            dispatch(
                setMessage(
                    ParseError(
                        'Поле &laquo;' +
                            title_error +
                            '&raquo; обязательно для заполнения.'
                    ),
                    'error'
                )
            );
            return;
        }

        props.openThirdStage();
    }

    render() {
        const props = this.props,
            { first_name, phone, email, delivery, addresses, comments } =
                this.state,
            delivery_disable = props.order.point.delivery_disable,
            styleObject = {
                active: {
                    background:
                        props.setting.rightModal.body.input.icon.inputNotEmpty
                            .background,
                    color: props.setting.rightModal.body.input.icon
                        .inputNotEmpty.color,
                    borderColor:
                        props.setting.rightModal.body.input.icon.inputNotEmpty
                            .borderColor,
                },
                notActive: {
                    background: props.setting.rightModal.body.input.background,
                    color: props.setting.rightModal.body.input.background,
                    borderColor:
                        props.setting.rightModal.body.input.borderColor,
                },
                label: {
                    color: props.setting.rightModal.body.secondColor,
                },
            },
            styleIconNotEmpty = {
                background:
                    props.setting.rightModal.body.input.icon.inputNotEmpty
                        .background,
                color: props.setting.rightModal.body.input.icon.inputNotEmpty
                    .color,
                borderColor:
                    props.setting.rightModal.body.input.icon.inputNotEmpty
                        .borderColor,
            },
            styleIconEmpty = {
                background:
                    props.setting.rightModal.body.input.icon.inputEmpty
                        .background,
                color: props.setting.rightModal.body.input.icon.inputEmpty
                    .color,
                borderColor:
                    props.setting.rightModal.body.input.icon.inputEmpty
                        .borderColor,
            },
            styleInput = {
                background: props.setting.rightModal.body.input.background,
                color: props.setting.rightModal.body.input.color,
                borderColor: props.setting.rightModal.body.input.borderColor,
            },
            styleText = {
                color: props.setting.rightModal.body.secondColor,
            };

        return (
            <div className={'shop-case-modal-wrapper'}>
                <div className="modal-scroll shop-case">
                    {props.isFetching ? <Loader /> : null}
                    <div className="mt-3 text-center" style={styleText}>
                        Как Вам удобно?
                    </div>
                    <div className="modal-group w-100 d-flex justify-content-center mt-2">
                        <div>
                            {!delivery_disable && (
                                <Checkbox
                                    id={'delivery'}
                                    value={delivery}
                                    onChange={this.changeCheckbox}
                                    caption="Доставка"
                                    styleObject={styleObject}
                                />
                            )}

                            <Checkbox
                                className="ml-2"
                                id={'delivery'}
                                value={!delivery}
                                onChange={this.changeCheckbox}
                                caption="Самовывоз"
                                styleObject={styleObject}
                            />
                        </div>
                    </div>
                    {props.user ? null : !props.setting.rightModal.noAuth.name
                          .visible &&
                      !props.setting.rightModal.noAuth.phone.visible &&
                      !props.setting.rightModal.noAuth.email.visible ? null : (
                        <div>
                            {!props.setting.rightModal.noAuth.name
                                .visible ? null : (
                                <div
                                    className={
                                        'modal-group d-inline-block px-3 mt-3 text-center w-' +
                                        props.setting.rightModal.noAuth.name
                                            .width
                                    }
                                >
                                    <InputGroup className="w-100">
                                        <InputGroupAddon
                                            addonType="prepend"
                                            style={
                                                first_name
                                                    ? styleIconNotEmpty
                                                    : styleIconEmpty
                                            }
                                        >
                                            <InputGroupText>
                                                {
                                                    props.setting.rightModal
                                                        .noAuth.name.title
                                                }
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            value={first_name}
                                            onChange={({ target: { value } }) =>
                                                this.changeInput(
                                                    value,
                                                    'first_name'
                                                )
                                            }
                                            style={styleInput}
                                        />
                                    </InputGroup>
                                </div>
                            )}
                            {!props.setting.rightModal.noAuth.phone
                                .visible ? null : (
                                <div
                                    className={
                                        'modal-group d-inline-block px-3 mt-3 text-center w-' +
                                        props.setting.rightModal.noAuth.phone
                                            .width
                                    }
                                >
                                    <IntlTelInput
                                        placeholder={
                                            props.setting.rightModal.noAuth
                                                .phone.title
                                        }
                                        preferredCountries={
                                            props.setting.content.primary
                                                .countries ||
                                            constPreferredCountries()
                                        }
                                        onlyCountries={constOnlyCountries()}
                                        onPhoneNumberChange={this.editPhone}
                                        value={phone}
                                        css={[
                                            'intl-tel-input w-100',
                                            'form-control w-100',
                                        ]}
                                        telInputProps={{
                                            style: styleInput,
                                        }}
                                    />
                                </div>
                            )}
                            {!props.setting.rightModal.noAuth.email
                                .visible ? null : (
                                <div
                                    className={
                                        'modal-group d-inline-block px-3 mt-3 text-center w-' +
                                        props.setting.rightModal.noAuth.email
                                            .width
                                    }
                                >
                                    <InputGroup className="w-100">
                                        <InputGroupAddon
                                            addonType="prepend"
                                            style={
                                                email
                                                    ? styleIconNotEmpty
                                                    : styleIconEmpty
                                            }
                                        >
                                            <InputGroupText>
                                                {
                                                    props.setting.rightModal
                                                        .noAuth.email.title
                                                }
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            value={email}
                                            onChange={({ target: { value } }) =>
                                                this.changeInput(value, 'email')
                                            }
                                            style={styleInput}
                                        />
                                    </InputGroup>
                                </div>
                            )}
                        </div>
                    )}
                    {delivery && !delivery_disable ? (
                        <div className={`d-flex flex-wrap ${s.input_wrapper}`}>
                            {_.map(
                                props.setting.rightModal.body.addresses,
                                (address, key) => {
                                    const state_address = addresses[key],
                                        { title, width } = address,
                                        val = state_address || '';
                                    return (
                                        <div
                                            key={key}
                                            className={`modal-group d-inline-block px-3 mt-3 `}
                                            style={{ flex: `0.${width}` }}
                                        >
                                            {!props.setting.rightModal.body
                                                .input.type ? (
                                                <InputGroup
                                                    className={`w-100 d-flex flex-nowrap`}
                                                    style={{
                                                        minWidth:
                                                            key === 0
                                                                ? '280px'
                                                                : 'auto',
                                                    }}
                                                >
                                                    <InputGroupAddon
                                                        addonType="prepend"
                                                        style={
                                                            val
                                                                ? styleIconNotEmpty
                                                                : styleIconEmpty
                                                        }
                                                    >
                                                        <InputGroupText>
                                                            {title}
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input
                                                        value={val}
                                                        onChange={({
                                                            target: { value },
                                                        }) =>
                                                            this.changeInput(
                                                                value,
                                                                'addresses',
                                                                key
                                                            )
                                                        }
                                                        style={styleInput}
                                                        className={s.input}
                                                    />
                                                </InputGroup>
                                            ) : (
                                                <div className="w-100">
                                                    <div
                                                        style={
                                                            val
                                                                ? styleIconNotEmpty
                                                                : styleIconEmpty
                                                        }
                                                    >
                                                        <span>{title}</span>
                                                    </div>
                                                    <Input
                                                        value={val}
                                                        onChange={({
                                                            target: { value },
                                                        }) =>
                                                            this.changeInput(
                                                                value,
                                                                'addresses',
                                                                key
                                                            )
                                                        }
                                                        style={styleInput}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    ) : null}
                    {_.map(
                        props.setting.rightModal.body.comments,
                        (comment, key) => {
                            const state_comment = comments[key],
                                { title, width, textarea } = comment,
                                val = state_comment || '';
                            return (
                                <div
                                    key={key}
                                    className={
                                        'modal-group d-inline-block px-3 mt-3 w-' +
                                        width
                                    }
                                >
                                    {textarea ? (
                                        <div>
                                            <div
                                                className={
                                                    !props.setting.rightModal
                                                        .body.input.type
                                                        ? 'textarea-header text-center border-bottom-0'
                                                        : ''
                                                }
                                                style={
                                                    val
                                                        ? styleIconNotEmpty
                                                        : styleIconEmpty
                                                }
                                            >
                                                {title}
                                            </div>
                                            <Input
                                                className={
                                                    !props.setting.rightModal
                                                        .body.input.type
                                                        ? 'textarea'
                                                        : ''
                                                }
                                                type="textarea"
                                                value={val}
                                                onChange={({
                                                    target: { value },
                                                }) =>
                                                    this.changeInput(
                                                        value,
                                                        'comments',
                                                        key
                                                    )
                                                }
                                                style={styleInput}
                                            />
                                        </div>
                                    ) : !props.setting.rightModal.body.input
                                          .type ? (
                                        <InputGroup className="w-100">
                                            <InputGroupAddon
                                                addonType="prepend"
                                                style={
                                                    val
                                                        ? styleIconNotEmpty
                                                        : styleIconEmpty
                                                }
                                            >
                                                <InputGroupText>
                                                    {title}
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                value={val}
                                                onChange={({
                                                    target: { value },
                                                }) =>
                                                    this.changeInput(
                                                        value,
                                                        'comments',
                                                        key
                                                    )
                                                }
                                                style={styleInput}
                                            />
                                        </InputGroup>
                                    ) : (
                                        <div className="w-100">
                                            <div
                                                style={
                                                    val
                                                        ? styleIconNotEmpty
                                                        : styleIconEmpty
                                                }
                                            >
                                                <span>{title}</span>
                                            </div>
                                            <Input
                                                value={val}
                                                onChange={({
                                                    target: { value },
                                                }) =>
                                                    this.changeInput(
                                                        value,
                                                        'comments',
                                                        key
                                                    )
                                                }
                                                style={styleInput}
                                            />
                                        </div>
                                    )}
                                </div>
                            );
                        }
                    )}
                </div>
                <div
                    className="modal-footer shop-case-footer"
                    style={{
                        background: props.setting.rightModal.footer.background,
                        borderColor:
                            props.setting.rightModal.footer.borderColor,
                    }}
                >
                    <Button
                        style={{
                            width: '100%',
                            height: '100%',
                            background:
                                props.setting.rightModal.footer.button
                                    .background,
                            color: props.setting.rightModal.footer.button.color,
                            borderColor:
                                props.setting.rightModal.footer.button
                                    .borderColor,
                        }}
                        onClick={this.confirmAction}
                    >
                        Далее
                    </Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = function mapStateToProps(state) {
    return {
        route: state.appState.route,
        setting: state.appState.setting,
        shopCase: state.shopState.shopCase,
        currency: state.pointsState.currency,
        user: state.authState.user,
        order: state.shopState.order,
        isFetching: state.orderState.storeData.isFetching,
        didInvalidate: state.orderState.storeData.didInvalidate,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        closeModal: function () {
            dispatch({
                type: 'closeRightModal',
            });
        },
        openThirdStage: () => {
            dispatch({
                type: 'openRightModal',
                HeadItem: ['Подтверждение заказа'],
                children: <ThirdStageLink />,
                onClose: () => {
                    dispatch({ type: 'closeRightModal' });
                },
            });
        },
        setOrderData: function (nameInput, value) {
            dispatch({
                type: 'set_order_data',
                nameInput: nameInput,
                value: value,
            });
        },
        dispatch,
    };
};

export const FirstStageModalLink = connect(
    mapStateToProps,
    mapDispatchToProps
)(FirstStageModal);
